// import lazyLoad from "@/common/lazyLoad";
import LoadableComponent from '@/common/loadable';

/**
 * 路由配置文件
 */
const Home = LoadableComponent(() => import("@/pages/home/Home"));
// const LocalProcessLibrary = LoadableComponent(() => import("@/pages/localProcessLibrary/LocalProcessLibrary"));
// const Flow = LoadableComponent(() => import("@/pages/flow/Flow"));
// const BlogDetail = LoadableComponent(() => import("@/pages/flow/third/Detail"));
// const User = LoadableComponent(() => import("@/pages/system/user/User"));
// const Menu = LoadableComponent(() => import("@/pages/system/menu/Menu"));
// const Role = LoadableComponent(() => import("@/pages/system/role/Role"));


export default [
  { 
    path: '/index', 
    exact: true, 
    component: Home 
  },
  { 
    path: '/article', 
    exact: true, 
    component: LoadableComponent(() => import("@/pages/article/Article")) 
  },
  { 
    path: '/collect', 
    exact: true, 
    component: LoadableComponent(() => import("@/pages/collect/Collect")) 
  },
  { 
    path: '/about', 
    exact: true, 
    component: LoadableComponent(() => import("@/pages/about/About")) 
  },

  // { path: '/localProcessLibrary', exact: true, component: LocalProcessLibrary },
  // { path: '/flow/flow1', exact: true, component: Flow },
  // // { path: '/blog2/list', exact: true, component: Home },
  // { path: '/blog2/blog3/detail', exact: true, component: BlogDetail },
  // { path: '/system/user', exact: true, component: User },
  // { path: '/system/role', exact: true, component: Role },
  // { path: '/system/menu', exact: true, component: Menu },
]
